// Librairies
import { Component, computed, input } from '@angular/core';

// Logo, or initials when the company has none.
@Component({
  selector: 'app-company-logo',
  standalone: true,
  templateUrl: './company-logo.component.html',
  styleUrl: './company-logo.component.scss',
  host: { '[style.--size.px]': 'size()' }
})

export class CompanyLogoComponent {
  // Signals
  readonly name = input<string>('');
  readonly logo = input<string | undefined>();
  readonly size = input<number>(36);

  readonly initials = computed(() =>
    this.name().split(/[\s.\-_]+/).filter(Boolean).slice(0, 2).map(word => word[0]).join('').toUpperCase()
  );
}
